import React from "react";
import { DataCardShell } from "../../../../../components/responsive";
import Helpers from "../../../../../components/Helpers";
import MasterRowActions from "../../../../../components/masterData/MasterRowActions";

export function ParishCategoryCard({
  row,
  isAdmin,
  onEdit,
  onDelete,
}: {
  row: any;
  isAdmin: boolean;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
}) {
  return (
    <DataCardShell
      title={row.name || "—"}
      subtitle={
        row.createdAt
          ? Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY")
          : undefined
      }
      primaryAction={
        isAdmin ? (
          <MasterRowActions
            onEdit={() => onEdit(row)}
            onDelete={() => onDelete(row)}
            showDelete={row.name !== "OTHER"}
          />
        ) : undefined
      }
    />
  );
}
